import { Component, HostBinding, HostListener, computed, inject, signal } from '@angular/core';
import { MDIconComponent, MDHeaderComponent } from '@melodic-ui/components';
import { ChatStateService } from '@lb/state/chat-state.service';
import { AuthenticationService } from '@lb/auth/services/authentication.service';
import { ChatMessageAreaComponent } from '@lb/components/chat-message-area/chat-message-area.component';

@Component({
	selector: 'lb-chat-slideout',
	standalone: true,
	imports: [MDIconComponent, MDHeaderComponent, ChatMessageAreaComponent],
	templateUrl: './chat-slideout.component.html',
	styleUrl: './chat-slideout.component.scss'
})
export class ChatSlideoutComponent {
	private _chatStateService = inject(ChatStateService);
	private _authService = inject(AuthenticationService);

	isOpen = this._chatStateService.isSlideoutOpen;
	isExpanded = signal(false);
	activeThread = this._chatStateService.activeThread;
	messages = this._chatStateService.messages;
	loading = this._chatStateService.loading;

	@HostBinding('class.is-open') get isOpenClass() {
		return this.isOpen();
	}

	@HostBinding('class.is-expanded') get isExpandedClass() {
		return this.isExpanded();
	}

	userInitials = computed(() => {
		const user = this._authService.getUser();
		if (!user?.firstName || !user?.lastName) return 'U';
		return `${user.firstName[0]}${user.lastName[0]}`.toUpperCase();
	});

	@HostListener('document:keydown.escape')
	onEscape(): void {
		if (this.isExpanded()) {
			this.isExpanded.set(false);
			return;
		}
		if (this.isOpen()) {
			this._chatStateService.closeSlideout();
		}
	}

	close(): void {
		this.isExpanded.set(false);
		this._chatStateService.closeSlideout();
	}

	toggleExpand(): void {
		this.isExpanded.update((v) => !v);
	}

	sendMessage(message: string): void {
		this._chatStateService.sendMessage(message);
	}
}
